import { Api } from "./api"

export class UserApi extends Api {
  constructor() {
    super('user', ['languagePreference', 'name', 'email', 'countryCode', 'password', 'passwordConfirmation', 'token', 'couponCode', 'termsOfService', 'timeZone', 'currentPassword', 'sawVideoTutorial', 'role', 'isQgrader', 'sawNavigationTutorial', 'isProducer'])
  }
}
